import { render } from "./EditReturnPage.vue?vue&type=template&id=6ee8dc96&ts=true"
import script from "./EditReturnPage.vue?vue&type=script&lang=ts"
export * from "./EditReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__